import { useState } from "react";
import { signup, verifyOtp, resendOtp } from "./api";
import { useNavigate } from "react-router-dom";

export default function Signup() {
  const [form, setForm] = useState({ name: "", email: "", password: "" });
  const [showOtp, setShowOtp] = useState(false);
  const [otp, setOtp] = useState("");
  const [loading, setLoading] = useState(false);
  const [resendLoading, setResendLoading] = useState(false);
  const [attemptsLeft, setAttemptsLeft] = useState(2);
  const [showPass, setShowPass] = useState(false);
  const navigate = useNavigate();

  const handleSignup = async () => {
    if (loading) return;
    const trimName = form.name.trim();
    const trimEmail = form.email.trim().toLowerCase();
    const trimPass = form.password.trim();
    if (!trimName || !trimEmail || !trimPass) return alert("Sab fields required hain");
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(trimEmail)) return alert("Valid email daalo");
    if (trimPass.length < 6) return alert("Password kam se kam 6 characters ka hona chahiye");
    setLoading(true);
    try {
      const res = await signup({ name: trimName, email: trimEmail, password: trimPass });
      const left = res.data?.attemptsLeft ?? 2;
      setAttemptsLeft(left);
      alert("OTP sent! Check your email 📩");
      setShowOtp(true);
    } catch (err) {
      alert(err.response?.data?.message || "Signup failed");
    } finally {
      setLoading(false);
    }
  };

  const handleResendOtp = async () => {
    if (resendLoading || attemptsLeft <= 0) return;
    setResendLoading(true);
    try {
      const res = await resendOtp({ email: form.email.trim().toLowerCase() });
      const left = res.data?.attemptsLeft ?? 0;
      setAttemptsLeft(left);
      alert("OTP resend ho gaya 📩 (" + left + " resend bacha)");
    } catch (err) {
      alert(err.response?.data?.message || "Resend failed");
    } finally {
      setResendLoading(false);
    }
  };

  const handleVerifyOtp = async () => {
    const trimOtp = otp.trim();
    if (!trimOtp) return alert("OTP daalo pehle");
    if (!/^\d{6}$/.test(trimOtp)) return alert("OTP 6 digit ka hona chahiye");
    try {
      const res = await verifyOtp({ email: form.email.trim().toLowerCase(), otp: trimOtp });
      alert("Signup complete!");
      localStorage.setItem("subai_session", "1");
      window.location.href = "/dashboard";
    } catch (err) {
      alert(err.response?.data?.message || "Server error");
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.card}>
        <h1 style={styles.title}>Create Account</h1>

        <input placeholder="Name" value={form.name} onChange={(e) => setForm({ ...form, name: e.target.value })} style={styles.input} disabled={showOtp} />
        <input placeholder="Email" value={form.email} onChange={(e) => setForm({ ...form, email: e.target.value })} style={styles.input} disabled={showOtp} autoComplete="email" />

        {/* PASSWORD with show/hide */}
        <div style={styles.passWrap}>
          <input
            type={showPass ? "text" : "password"}
            placeholder="Password"
            value={form.password}
            onChange={(e) => setForm({ ...form, password: e.target.value })}
            style={{ ...styles.inputInner }}
            disabled={showOtp}
            autoComplete="new-password"
          />
          <span onClick={() => setShowPass(!showPass)} style={styles.eyeBtn}>{showPass ? "🙈" : "👁️"}</span>
        </div>

        {!showOtp && (
          <button onClick={handleSignup} disabled={loading} style={{ ...styles.btn, opacity: loading ? 0.6 : 1 }}>
            {loading ? "Sending..." : "Signup"}
          </button>
        )}

        {showOtp && (
          <div style={styles.otpBox}>
            <p style={styles.otpInfo}>OTP bheja gaya 📩 <strong style={{ color: "#FF6B00" }}>{form.email}</strong> pe</p>

            <input
              placeholder="6-digit OTP"
              value={otp}
              onChange={(e) => setOtp(e.target.value.replace(/\D/g, "").slice(0, 6))}
              style={{ ...styles.input, letterSpacing: 6, textAlign: "center", fontSize: 22, fontWeight: 700 }}
              maxLength={6}
              inputMode="numeric"
            />

            <button onClick={handleVerifyOtp} style={styles.verifyBtn}>✅ Verify OTP</button>

            <div style={{ textAlign: "center" }}>
              {attemptsLeft > 0 ? (
                <span onClick={handleResendOtp} style={{ ...styles.linkBtn, opacity: resendLoading ? 0.5 : 1, cursor: resendLoading ? "not-allowed" : "pointer" }}>
                  {resendLoading ? "Sending..." : "🔄 Resend OTP (" + attemptsLeft + " left)"}
                </span>
              ) : (
                <span style={{ color: "#FF8A93", fontSize: 13 }}>OTP limit khatam. Kal try karo ❌</span>
              )}
            </div>
          </div>
        )}

        <p style={styles.link}>
          Already have an account?
          <span onClick={() => navigate("/")} style={styles.linkBtn}> Login</span>
        </p>
      </div>
    </div>
  );
}

const styles = {
  page: { minHeight: "100vh", background: "#0B0B10", display: "flex", justifyContent: "center", alignItems: "center", fontFamily: "var(--font-ui)", padding: 16 },
  card: { width: 320, maxWidth: "100%", padding: 32, borderRadius: 20, background: "rgba(24,24,31,0.9)", backdropFilter: "blur(16px)", border: "1px solid rgba(255,255,255,0.08)", boxShadow: "0 1px 1px rgba(0,0,0,0.3), 0 24px 48px rgba(0,0,0,0.5)", display: "flex", flexDirection: "column", gap: 12, boxSizing: "border-box" },
  title: { color: "#F5F5F7", textAlign: "center", marginBottom: 8, fontSize: 20, fontWeight: 700 },
  input: { background: "#1E1E26", border: "1px solid #38383F", borderRadius: 9999, padding: "12px 16px", color: "#F5F5F7", outline: "none", boxSizing: "border-box", fontSize: 14, fontFamily: "var(--font-ui)" },
  passWrap: { display: "flex", alignItems: "center", background: "#1E1E26", border: "1px solid #38383F", borderRadius: 9999, paddingRight: 14 },
  inputInner: { flex: 1, background: "transparent", border: "none", padding: "12px 16px", color: "#F5F5F7", outline: "none", fontSize: 14, fontFamily: "var(--font-ui)" },
  eyeBtn: { cursor: "pointer", fontSize: 16, userSelect: "none" },
  btn: { background: "#7C5CFF", border: "none", padding: "13px", borderRadius: 9999, color: "#F5F5F7", fontWeight: 700, fontSize: 14, textTransform: "uppercase", letterSpacing: 0.6, cursor: "pointer", marginTop: 10, boxShadow: "0 8px 20px rgba(124,92,255,0.3)" },
  otpBox: { marginTop: 10, display: "flex", flexDirection: "column", gap: 10 },
  otpInfo: { color: "#A8A8B3", fontSize: 13, textAlign: "center", margin: 0 },
  verifyBtn: { background: "#22D3C5", border: "none", padding: "12px", borderRadius: 9999, color: "#0B0B10", fontWeight: 700, fontSize: 13, textTransform: "uppercase", letterSpacing: 0.6, cursor: "pointer" },
  link: { color: "#A8A8B3", textAlign: "center", fontSize: 13, marginTop: 10 },
  linkBtn: { color: "#B3A1FF", cursor: "pointer", fontSize: 13, fontWeight: 600 }
};
